import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidemenu";

const EmailPopup = ({
  showEmailPopup,
  handleFormSubmit,
  resetForm,
  handleFileChange,
  fromName,
  setFromName,
  emailAddress,
  setEmailAddress,
  messageSubject,
  setMessageSubject,
}) => {
  const emailPopupStyles = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "white",
    padding: "20px",
    border: "1px solid #ccc",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    zIndex: 999,
    width: "400px",
    height: "400px",
    maxWidth: "80%",
    borderRadius: "15px",
    overflow: "auto",
    marginRight: "300px",
  };

  const emailPopupSentenceStyles = {
    color: "#00008B",
    fontWeight: "bold",
    fontSize: "20px",
    marginBottom: "20px",
    textAlign: "center",
  };

  const labelStyles = {
    fontWeight: "bold",
    marginBottom: "10px",
  };

  const inputStyles = {
    width: "100%",
    marginBottom: "20px",
    height: "30px",
  };

  const textareaStyles = {
    width: "100%",
    marginBottom: "20px",
    height: "150px",
  };

  const buttonStyles = {
    backgroundColor: "#4caf50",
    color: "white",
    padding: "10px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginRight: "10px",
  };

  const closeButtonStyles = {
    ...buttonStyles,
    backgroundColor: "#f44336",
  };

  const closeButtonHoverStyles = {
    backgroundColor: "#d32f2f",
  };

  return (
    showEmailPopup && (
      <div style={emailPopupStyles}>
        <form onSubmit={handleFormSubmit}>
          <div style={emailPopupSentenceStyles}>SEND EMAIL</div>
          <label style={labelStyles}>From Email Address</label>
          <textarea
            value={fromName}
            onChange={(e) => setFromName(e.target.value)}
            required
            style={{ ...textareaStyles, height: "30px" }}
          />
          <br />
          <label style={labelStyles}>To Email Address</label>
          <input
            type="email"
            value={emailAddress}
            onChange={(e) => setEmailAddress(e.target.value)}
            required
            style={inputStyles}
          />
          <br />
          <label style={labelStyles}>Message Subject</label>
          <textarea
            value={messageSubject}
            onChange={(e) => setMessageSubject(e.target.value)}
            required
            style={{ ...textareaStyles, height: "40px" }}
          />
          <br />
          <label style={labelStyles}>Attachment</label>
          <input type="file" onChange={handleFileChange} style={inputStyles} />
          <br />
          <button type="submit" style={buttonStyles}>
            Submit
          </button>
          <button
            type="button"
            onClick={resetForm}
            style={closeButtonStyles}
            onMouseEnter={(e) =>
              (e.target.style.backgroundColor =
                closeButtonHoverStyles.backgroundColor)
            }
            onMouseLeave={(e) =>
              (e.target.style.backgroundColor =
                closeButtonStyles.backgroundColor)
            }
          >
            Close
          </button>
        </form>
      </div>
    )
  );
};

const Temp = () => {
  const [templates, setTemplates] = useState([]);

  const [selectedTemplateName, setSelectedTemplateName] = useState(null);
  const [fromName, setFromName] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [messageSubject, setMessageSubject] = useState("");
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [attachment, setAttachment] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadTemplates = async () => {
      const fetchedTemplates = await fetchAllTemplates();
      setTemplates(fetchedTemplates);
    };
    loadTemplates();
  }, []);

  const fetchAllTemplates = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/allTemplatePreviews`
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch templates: ${response.statusText}`);
      }

      const data = await response.json();
      if (data.success) {
        return data.templates; // Assumes templates have 'name' and 'preview' properties
      } else {
        throw new Error("Failed to load templates");
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
      return [];
    }
  };

  const handleSelect = async (templateName) => {
    try {
      const selectResponse = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/selectTemplate/${templateName}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            templateName,
          }),
        }
      );

      if (selectResponse.ok) {
        console.log("File found on the server.");
        console.log("Selected Template:", templateName);

        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/templateContent/${templateName}`
        );

        if (!response.ok) {
          throw new Error(
            `Failed to fetch template content. Status: ${response.status}`
          );
        }

        const data = await response.json();

        if (data.success) {
          console.log("Template Content:", data.templateContent);
          setSelectedTemplateName(templateName);
          setShowEmailPopup(true);
          navigate("/frontend", {
            state: { templateContent: data.templateContent, templateName },
          });
        } else {
          console.error("Error fetching template content:", data.error);
        }
      } else {
        console.error("File not found on the server.");
      }
    } catch (error) {
      console.error("Error fetching template content:", error.message);
    }
  };

  // Handle file change for attachment
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setAttachment(file);

    const reader = new FileReader();
    reader.onload = (event) => {
      const fileContent = event.target.result;
      console.log("Selected File Content:", fileContent);

      const fileName = file.name;
      console.log("Attachment Name:", fileName);
    };
    reader.readAsDataURL(file);
  };

  // Handle click to show email popup
  const handleSendClick = () => {
    setShowEmailPopup(true);
  };

  // Handle form submission for sending email
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      const fileName = attachment ? attachment.name : null;

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/sendEmail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            templateName: selectedTemplateName,
            fromName,
            emailAddress,
            messageSubject,
            attachment: fileName,
          }),
        }
      );

      if (response.ok) {
        console.log("Email sent successfully!");
      } else {
        throw new Error(`Failed to send email. Status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error sending email:", error.message);
    }

    resetForm();
  };

  // Function to reset form fields
  const resetForm = () => {
    setSelectedTemplateName(null);
    setFromName("");
    setEmailAddress("");
    setMessageSubject("");
    setAttachment(null);
    setShowEmailPopup(false);
  };

  return (
    <div className="container-fluid" style={{ display: "flex" }}>
      <Sidebar />
      <div
        className="segment-container"
        style={{ width: "100%",height:'100vh',overflowY:'auto' }}
      >
        <div style={{marginTop:'50px'}}>
          <div style={{display:'flex',justifyContent:'space-between',height:'70px'}}>
          <div
            style={{
              fontSize: "30px",
            }}
          >
            New Segment Email
          </div>
          <button
            onClick={handleSendClick}
            style={{
              backgroundColor: "#4caf50",
              color: "white",
              borderRadius: "5px",
              cursor: "pointer",
              border: "none",
              margin:'5px',
              height:'50px'
            }}
          >
            Send Email
          </button>
          </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              position: "relative",
              background: "#EEEEEE",
            }}
          >
            {templates.map(({ name, preview }) => (
              <div
                key={name}
                style={{
                  width: "320px",
                  height: "400px", // Fixed height for the card
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  overflow: "hidden",
                  position: "relative", // Required for scaling
                  cursor: "pointer",
                  userSelect: "none",
                  background: "white",
                }}
                onClick={() => handleSelect(name)}
              >
                {/* Scaled container */}
                <div
                  style={{
                    transform: "scale(0.5)", // Adjust scale as needed
                    transformOrigin: "top left", // Scale from the top-left corner
                    width: "200%",
                    height: "200%",
                  }}
                >
                  {/* Iframe for template preview */}
                  <iframe
                    srcDoc={preview} // Assumes 'preview' contains the raw HTML string for preview
                    title={name}
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      pointerEvents: "none",
                    }}
                    scrolling="no"
                  />
                </div>
                {/* Template name */}
                <div
                  style={{
                    padding: "10px",
                    textAlign: "center",
                    fontSize: "14px",
                  }}
                >
                  {name}
                </div>
              </div>
            ))}
          </div>

          {/* Render the EmailPopup component */}
          <EmailPopup
            showEmailPopup={showEmailPopup}
            handleFormSubmit={handleFormSubmit}
            resetForm={resetForm}
            handleFileChange={handleFileChange}
            fromName={fromName}
            setFromName={setFromName}
            emailAddress={emailAddress}
            setEmailAddress={setEmailAddress}
            messageSubject={messageSubject}
            setMessageSubject={setMessageSubject}
          />
        </div>
      </div>
  );
};

export default Temp;
